/* Mirelyae — fiche « bague initiales » : paliers, gravure par bague, écrin, ajout au panier Horizon, barre d'achat fixe. */
import { CartLinesUpdateEvent } from '@shopify/events';

const euro = (c) => (c / 100).toLocaleString('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).replace(/ /g, '');
const LETTRE = /^[A-Z]$/;

class LzAchat extends HTMLElement {
  connectedCallback() {
    this.tiers = [...this.querySelectorAll('[data-tier]')];
    this.rings = [...this.querySelectorAll('[data-ring]')];
    this.same = this.querySelector('[data-same]');
    this.gift = this.querySelector('[data-gift]');
    this.btn = this.querySelector('[data-add]');
    this.err = this.querySelector('[data-err]');
    this.tiers.forEach((t) => t.addEventListener('change', () => this.update()));
    this.same?.addEventListener('change', () => this.update());
    this.gift?.addEventListener('change', () => this.update());
    this.addEventListener('click', (e) => {
      const c = e.target.closest('[data-colour]');
      if (c) { this.setColour(c); return; }
    });
    this.addEventListener('input', (e) => {
      const i = e.target.closest('[data-letter]');
      if (!i) return;
      i.value = i.value.toUpperCase().normalize('NFD').replace(/[^A-Z]/g, '').slice(0, 1);
      if (i.value && i.dataset.side === 'g') i.closest('[data-ring]').querySelector('[data-side="d"]')?.focus();
      this.update();
    });
    this.btn?.addEventListener('click', () => this.add());
    this.update();
    this.sticky();
  }
  get tier() { return this.tiers.find((t) => t.checked) || this.tiers[0]; }
  setColour(b) {
    const ring = b.closest('[data-ring]');
    ring.querySelectorAll('[data-colour]').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
    ring.dataset.colourValue = b.dataset.colour;
    ring.querySelector('[data-colour-label]').textContent = b.dataset.colour;
    const media = parseInt(b.dataset.media || '-1', 10);
    const show = document.querySelector('main slideshow-component');
    if (media >= 0 && show?.select) show.select(media);
    this.update();
  }
  letters(ring) {
    const src = this.same?.checked ? this.rings[0] : ring;
    return [src.querySelector('[data-side="g"]').value, src.querySelector('[data-side="d"]').value];
  }
  update() {
    const t = this.tier, n = parseInt(t.dataset.units, 10);
    this.tiers.forEach((x) => x.closest('.lz-tier').classList.toggle('is-on', x === t));
    // La personnalisation (couleur + initiales) s'affiche DANS la carte choisie
    const corps = t.closest('.lz-tier').querySelector('[data-corps]');
    const perso = this.querySelector('[data-perso]');
    if (corps && perso && perso.parentElement !== corps) corps.appendChild(perso);
    this.rings.forEach((r, i) => {
      r.hidden = i >= n;
      const copy = this.same?.checked && i > 0;
      r.classList.toggle('is-copy', copy);
      const [g, d] = this.letters(r);
      r.querySelectorAll('[data-preview]').forEach((p) => (p.textContent = `${g || 'A'} & ${d || 'B'}`));
    });
    this.querySelector('[data-same-row]')?.toggleAttribute('hidden', n < 2);
    const gift = this.gift?.checked ? parseInt(this.gift.dataset.price, 10) * n : 0;
    const total = parseInt(t.dataset.price, 10) + gift;
    this.btn.querySelector('[data-total]').textContent = euro(total);
    document.querySelectorAll('[data-lz-price]').forEach((e) => (e.textContent = euro(parseInt(t.dataset.price, 10))));
    document.querySelectorAll('[data-lz-compare]').forEach((e) => (e.textContent = euro(parseInt(t.dataset.compare, 10))));
    document.querySelectorAll('[data-lz-pct]').forEach((e) => (e.textContent = '−' + Math.round((1 - t.dataset.price / t.dataset.compare) * 100) + ' %'));
    document.querySelectorAll('[data-lz-sticky-total]').forEach((e) => (e.textContent = euro(total)));
    if (this.err) this.err.hidden = true;
  }
  async add() {
    const t = this.tier, n = parseInt(t.dataset.units, 10);
    const props = {};
    for (let i = 0; i < n; i++) {
      const r = this.rings[i];
      const [g, d] = this.letters(r);
      if (!LETTRE.test(g || '') || !LETTRE.test(d || '')) {
        this.err.hidden = false;
        const champ = (this.same?.checked ? this.rings[0] : r).querySelector(!LETTRE.test(g || '') ? '[data-side="g"]' : '[data-side="d"]');
        champ.scrollIntoView({ behavior: 'smooth', block: 'center' }); champ.focus({ preventScroll: true });
        return;
      }
      props[`Prsten ${i + 1}`] = `${r.dataset.colourValue} — ${g} & ${d}`;
    }
    const items = [{ id: parseInt(t.dataset.vid, 10), quantity: 1, properties: props }];
    if (this.gift?.checked) items.push({ id: parseInt(this.gift.dataset.vid, 10), quantity: n });
    this.btn.classList.add('mir-chargement');
    const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((x) => ({ merchandiseId: String(x.id), quantity: x.quantity })), promise: deferred.promise }));
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: sections.join(',') }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: data.sections, didError: false, source: 'mir-lz', itemCount: n } });
    } catch (e) {
      deferred.reject(e);
      this.err.textContent = e.message; this.err.hidden = false;
    } finally {
      this.btn.classList.remove('mir-chargement');
    }
  }
  sticky() {
    const bar = document.querySelector('[data-lz-sticky]');
    if (!bar || !this.btn) return;
    new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(this.btn);
    bar.querySelector('button')?.addEventListener('click', () => this.btn.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  }
}
if (!customElements.get('lz-achat')) customElements.define('lz-achat', LzAchat);

/* Accordéons « une seule ligne ouverte » dans les blocs lz */
document.addEventListener('toggle', (e) => {
  const d = e.target;
  if (!(d instanceof HTMLDetailsElement) || !d.open || !d.closest('[data-lz-single]')) return;
  d.closest('[data-lz-single]').querySelectorAll('details[open]').forEach((o) => o !== d && (o.open = false));
}, true);
